import Vue from 'vue';
export default {
    kecData: [],
    regionInfos: {},
    osImages: [],
    imageSet: {},
    pTypeConfig: '',
    disCountObj: {},
    snapList:[],
    snapTotal: 0,
    checkTryOrder: 0,
    kecPriceSet: 0,
    kecTryOrder: 0,
    // ebsNameMap: {
    //     'SSD':  '云硬盘osImages(SSD)',//Vue.$trans(`云硬盘（SSD）`), //'云硬盘osImages(SSD)',
    //     'SATA':'云硬盘(SATA)' //Vue.$trans(`云硬盘（SATA）`) //'云硬盘(SATA)'
    // },
    soldoutList:[]
}